'use strict';

import { parseJson, normalizeCurrencyCode } from './bambuserFormatters';

export function getCartIntegrationConfig () {
    var page = document.querySelector('.js-liveShoppingPage')
        || document.querySelector('.js-bambuserCartConfig');
    var configRaw = page
        ? page.getAttribute('data-bambuser-cart-config')
        : null;
    var parsed = parseJson(configRaw) || {};

    var config = {
        sdkUrl: parsed.sdkUrl || 'https://lcx-embed-eu.bambuser.com/default/embed.js',
        productDataUrl: parsed.productDataUrl || null,
        addToCartUrl: parsed.addToCartUrl || null,
        removeFromCartUrl: parsed.removeFromCartUrl || null,
        cartStateUrl: parsed.cartStateUrl || null,
        checkoutUrl: parsed.checkoutUrl || null,
        locale: parsed.locale || 'en-US',
        currency: normalizeCurrencyCode(parsed.currency || 'EUR'),
    };

    return config;
}
